module.exports = __webpack_public_path__ + "static/media/Success-Alt.768b4ac0.svg";